import Colcade from 'colcade';

import './journal.scss';

const COMPONENT_NAME = 'journal';

const BEM = {
  BLOCK: COMPONENT_NAME,
  ELEMENT_GRID: 'journal__grid',
  ELEMENT_COL: 'journal__grid__col',
  ELEMENT_ITEM: 'journal__item',
};

/**
 * version    1.0
 * class      <type> (Journal)
 */
export class Journal {
  constructor($container = $('body')) {
    this._els = {};
    this._els.container = $container;
    this._els.journal = this._els.container.find(`.${BEM.BLOCK}`);
    this._els.grid = this._els.container.find(`.${BEM.ELEMENT_GRID}`);

    if (this._els.grid.length > 0) {
      // eslint-disable-next-line no-new
      new Colcade(this._els.grid[0], {
        columns: `.${BEM.ELEMENT_COL}`,
        items: `.${BEM.ELEMENT_ITEM}`,
      });
    }
  }
}
